femcare.article.pageHeaderHero = {
    init: function () {
        $.widget('femcare.pageHeaderHeroWidget', {
            options: {},

            _create: function () {
                this.$mediaHero = this.element.prev('.media-hero');

                if (this.$mediaHero.find('.js-youtube-embed').length === 0 &&
                    this.$mediaHero.find('.media-hero__video').length === 0) {
                    return;
                }

                femcare.shared.pubsub.subscribe('VIDEO_PLAY', this._onVideoPlay.bind(this));
                femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_PLAYS', this._onVideoPlay.bind(this));

                femcare.shared.pubsub.subscribe('VIDEO_STOP', this._onVideoFinish.bind(this));
                femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_STOP', this._onVideoFinish.bind(this));

                femcare.shared.pubsub.subscribe('VIDEO_FINISH', this._onVideoFinish.bind(this));
                femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_FINISH', this._onVideoFinish.bind(this));

            },

            _onVideoPlay: function (data) {
                if (this._isVideoWithinGallery(data.$trigger)) {
                    this._animatePanel(true);
                } else {
                    this._animatePanel(false);
                }
            },

            _onVideoFinish: function (data) {
                if (this._isVideoWithinGallery(data.$trigger)) {
                    this._animatePanel(false);
                }
            },

            _animatePanel: function (applyMove) {
                this.element.toggleClass('page-header-hero--move', applyMove);
            },

            _isVideoWithinGallery: function ($videoTrigger) {
                return this.$mediaHero.find($videoTrigger).length;
            }
        });

        $('.page-header-hero').pageHeaderHeroWidget();
    }
};